import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSettings } from "./api";

const SettingsCtx = createContext({ settings: null });
export const useSettings = () => useContext(SettingsCtx);

const LeadCtx = createContext({ openLead: () => {}, closeLead: () => {}, lead: null });
export const useLead = () => useContext(LeadCtx);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    getSettings().then(setSettings).catch(() => {});
  }, []);
  return (
    <SettingsCtx.Provider value={{ settings }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export function LeadProvider({ children }) {
  const [lead, setLead] = useState(null);
  const openLead = useCallback((opts = {}) => {
    setLead({ ...opts, _t: Date.now() });
  }, []);
  const closeLead = useCallback(() => setLead(null), []);
  return (
    <LeadCtx.Provider value={{ lead, openLead, closeLead, isOpen: !!lead }}>
      {children}
    </LeadCtx.Provider>
  );
}
